import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
import '../../assets/scripts/jquery.select.js'
$("header .nav a").eq(0).addClass("active")
var swiper1 = new Swiper(".section1 .mySwiper", {
    observer:true,//修改swiper自己或子元素时，自动初始化swiper
    observeParents:true,//修改swiper的父元素时，自动初始化swiper
    slidesPerView: 2,
    spaceBetween: 20,
    navigation: {
        nextEl: ".section1 .swiper-button-next",
        prevEl: ".section1 .swiper-button-prev",
    },
    breakpoints: {
        320: {
            slidesPerView: 1,
        },
        768: {  //当屏幕宽度大于等于1280
            slidesPerView: 2,
            spaceBetween: 20,
        }
    }
});
var swiper2 = new Swiper(".section2 .swiper", {
    observer:true,//修改swiper自己或子元素时，自动初始化swiper
    observeParents:true,//修改swiper的父元素时，自动初始化swiper
    slidesPerView: 2,
    spaceBetween: 20,
    navigation: {
        nextEl: ".section2 .swiper-button-next",
        prevEl: ".section2 .swiper-button-prev",
    },
    breakpoints: {
        320: {
            slidesPerView: 1,
        },
        768: {  //当屏幕宽度大于等于1280
            slidesPerView: 2,
            spaceBetween: 20,
        }
    }
});
var swiper3 = new Swiper(".section3 .mySwiper", {
    observer:true,//修改swiper自己或子元素时，自动初始化swiper
    observeParents:true,//修改swiper的父元素时，自动初始化swiper
    slidesPerView: 2,
    spaceBetween: 20,
    navigation: {
        nextEl: ".section3 .swiper-button-next",
        prevEl: ".section3 .swiper-button-prev",
    },
    breakpoints: {
        320: {
            slidesPerView: 1,
        },
        768: {  //当屏幕宽度大于等于1280
            slidesPerView: 2,
            spaceBetween: 20,
        }
    }
});
var swiper4 = new Swiper(".section4 .mySwiper", {
    observer:true,//修改swiper自己或子元素时，自动初始化swiper
    observeParents:true,//修改swiper的父元素时，自动初始化swiper
    slidesPerView: 2,
    spaceBetween: 20,
    navigation: {
        nextEl: ".section4 .swiper-button-next",
        prevEl: ".section4 .swiper-button-prev",
    },
    breakpoints: {
        320: {
            slidesPerView: 1,
        },
        768: {  //当屏幕宽度大于等于1280
            slidesPerView: 2,
            spaceBetween: 20,
        }
    }
});
var swiper5 = new Swiper(".section5 .mySwiper", {
    observer:true,//修改swiper自己或子元素时，自动初始化swiper
    observeParents:true,//修改swiper的父元素时，自动初始化swiper
    slidesPerView: 2,
    spaceBetween: 20,
    navigation: {
        nextEl: ".section5 .swiper-button-next",
        prevEl: ".section5 .swiper-button-prev",
    },
    breakpoints: {
        320: {
            slidesPerView: 1,
        },
        768: {  //当屏幕宽度大于等于1280
            slidesPerView: 2,
            spaceBetween: 20,
        }
    }
});
var swiper6 = new Swiper(".section6 .mySwiper", {
    observer:true,//修改swiper自己或子元素时，自动初始化swiper
    observeParents:true,//修改swiper的父元素时，自动初始化swiper
    slidesPerView: 2,
    spaceBetween: 20,
    navigation: {
        nextEl: ".section6 .swiper-button-next",
        prevEl: ".section6 .swiper-button-prev",
    },
    breakpoints: {
        320: {
            slidesPerView: 1,
        },
        768: {  //当屏幕宽度大于等于1280
            slidesPerView: 2,
            spaceBetween: 20,
        }
    }
});
$('select.select').select();